import Dialog from "@mui/material/Dialog";
import styled from "styled-components";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import IconLoading from "@/static/images/loading.png";
import IconError from "@/static/images/modal/error.png";
import IconSuccess from "@/static/images/modal/success.png";
import IconInfo from "@/static/images/modal/info.png";
import IconWarn from "@/static/images/modal/warn.png";

export const dialogTheme = createTheme({
  components: {
    MuiDialog: {
      styleOverrides: {
        root: {
          '&.mobile-dialog .MuiPaper-root': {
            maxWidth: '85vw',
            width: 'auto',
            boxSizing: 'border-box',
            padding: 'min(5.33vw, 30px) 0 min(8vw, 40px)',

            '& .closeicon': {
              top: 'min(2.67vw, 15px)',
              right: 'min(2.67vw, 15px)',
            }
          },
          '&.nobutton-dialog .MuiPaper-root': {
            minWidth: "auto",
            maxWidth: "600px",
            width: 'auto',
            padding: "28px",
            borderRadius: '8px',
            margin: '0',
          },
          '&.nobutton-dialog .dialog-icon': {
            marginRight: '12px',
          },
          '&.nobutton-dialog .MuiDialogContent-root': {
            marginTop: '0',
            padding: '0',
            display: "flex",
            alignItems: "center",
            fontSize: '18px',
            fontWeight: 'bold',
          },
          '&.nobutton-dialog .MuiCircularProgress-root': {
            color: '#333',
          }
        },
        paper: {
          minWidth: "360px",
          maxWidth: "auto",
          // padding: "25px 12px",
          padding: "30px",
          borderRadius: '8px',
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontSize: "20px!important",
          fontWeight: "600",
          color: "#333333",
          padding: "0",
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          overflow: 'visible',
          marginTop: '20px',
          textAlign: "center",
          lineHeight: "22px",
          fontSize: "16px",
          color: "#333333",
          padding: 0,

          "&.no-title": {
            marginTop: 0,
            //padding: '30px 0 40px',
          },
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "30px",
          padding: '0',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          border: 'none',
          backgroundColor: "#eee",
          color: "#333333",
          fontSize: "14px",
          fontFamily: "PingFangSC-Medium",
          fontWeight: "500",
          padding: "0px 20px",
          height: "32px",
          lineHeight: "32px",
          textTransform: "none",
          minWidth: '120px',

          "&:not(:first-of-type)": {
            marginLeft: "30px",
          },

          "&.MuiLoadingButton-loading": {
            paddingLeft: "28px",
          },

          "& .MuiLoadingButton-loadingIndicatorStart": {
            left: "22px",
          },

          "& .MuiButton-startIcon": {
            marginRight: '0',
            marginLeft: '0',
          },

          "& .MuiButton-startIcon .MuiCircularProgress-root": {
            marginRight: '8px',
            color: "inherit",
          },

          "&:hover": {
            backgroundColor: "#ddd",
            border: 'none',
          },
        },
        contained: {
          backgroundColor: "#333",
          color: "#fff",
          textTransform: "inherit",

          "&:hover": {
            backgroundColor: "#666",
            color: "#fff",
          },
        },
        outlined: {},
      },
    },
    MuiLoadingButton: {
      styleOverrides: {
        loading: {
          marginRight: "140px",
        },
      },
    },
  },
});

export const DialogIcon = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
`

export const TypeIcon = styled.i`
  width: ${(props) => `${props.size || 20}px`};
  height: ${(props) => `${props.size || 20}px`};
  background-size: 100%;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  &.loading {
    position: relative;
    overflow: hidden;

    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      animation: spin 1s steps(8) infinite;
      background-image: url(${IconLoading});
      background-size: 100%;
    }
  }

  &.error {
    background-image: url(${IconError});
  }

  &.success {
    background-image: url(${IconSuccess});
  }

  &.warn {
    background-image: url(${IconWarn});
  }

  &.info {
    background-image: url(${IconInfo});
  }
`;

export const DialogWrapper = styled(Dialog)`
  .title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    // font-family: Helvetica, Arial, Verdana, sans-serif;
    // font-weight: 600;
    color: #333333;
  }
  .link {
    margin: 10px auto;
    color: #2d67f6;
    a {
      color: #2d67f6;
      font-size: 12px;
      // font-family: PingFang SC;
      font-weight: 400;
    }
  }
  .closeicon {
    position: absolute;
    right: 15px;
    top: 15px;
    color: #b3adad;
    svg {
      cursor: pointer;
      transition: transform .3s ease 0s;

      &:hover {
        transform: rotate(270deg);
      }
    }
  }
`;
